/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState, DeploymentStatus, StackDeployment } from '@modules/ui-types'

import { setDeploymentMonitoringRequest } from '@/reducers/asyncRequests/registry'

import {
  setDeploymentMonitoring,
  stopDeploymentMonitoring,
} from '../../../../actions/stackDeployments'
import { getConfigForKey } from '../../../../selectors'

import EditMonitoring from './EditMonitoring'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  isHeroku: boolean
  setDeploymentMonitoringRequest: AsyncRequestState
}

type UpdateMonitoringSettings = {
  deploymentFrom: StackDeployment
  deploymentTo: StackDeployment
  logsMonitoring: boolean
  metricsMonitoring: boolean
}

interface DispatchProps {
  setDeploymentMonitoring: (settings: UpdateMonitoringSettings) => void
  stopDeploymentMonitoring: (deploymentId: string) => void
}

interface ConsumerProps {
  deployment: StackDeployment
  status: DeploymentStatus
}

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => ({
  setDeploymentMonitoringRequest: setDeploymentMonitoringRequest(state, deployment.id),
  isHeroku: getConfigForKey(state, `APP_FAMILY`) === `heroku`,
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  stopDeploymentMonitoring: (deploymentId: string) =>
    dispatch(stopDeploymentMonitoring(deploymentId)),
  setDeploymentMonitoring: (settings: UpdateMonitoringSettings) =>
    dispatch(setDeploymentMonitoring(settings)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(EditMonitoring)
